import { inject, Injectable } from '@angular/core';
import { UserInfo } from '@lib/auth/user-info.model';
import { AuthService } from '@lib/auth/auth.service';
import { COMMON_ENVIRONMENT } from '@lib/core/environment/common-environment';
import { APP_AUDIENCE, AppAudience } from '@lib/core/environment/app-audience';

@Injectable({
  providedIn: 'root',
})
export class ApereoAuthService extends AuthService {
  private readonly environment = inject(COMMON_ENVIRONMENT);
  private readonly appAudience = inject(APP_AUDIENCE);

  public login(): UserInfo | undefined {
    const matchAccessToken = window.location.hash.match(/#access_token=(.*?)&/);
    if (matchAccessToken) {
      this.setToken(matchAccessToken[1]);
      window.location.hash = '';
      const userInfo = this.parseToken();

      if (
        (userInfo.userDir === 'Consultant' &&
          this.appAudience === ('shm' as AppAudience)) ||
        (userInfo.userDir !== 'Consultant' &&
          this.appAudience === ('consultant' as AppAudience))
      ) {
        return undefined;
      }

      this._userInfo.set(userInfo);
      return userInfo;
    }

    const redirectTo = encodeURIComponent(window.location.href);
    const url = `${this.environment.auth.loginUrl}?response_type=token&client_id=${this.environment.auth.clientId}&redirect_uri=${redirectTo}`;
    window.location.replace(url);
    return;
  }

  public logout() {
    sessionStorage.removeItem(AuthService.TOKEN_KEY);
    window.location.href = this.environment.auth.logoutUrl;
  }
}
